import { Module } from '../shared/model'
import { useAppSelector } from '../store/hooks'

export function groupBy<T, K extends keyof T>(array: T[], key: K) {
  const map = new Map<T[K], T[]>()
  array.forEach((item) => {
    const itemKey = item[key]
    if (!map.has(itemKey)) {
      map.set(
        itemKey,
        array.filter((i) => i[key] === item[key]),
      )
    }
  })
  return map
}

function upperFirst(string: string) {
  return string.slice(0, 1).toUpperCase() + string.slice(1, string.length)
}

export function snakeToPascal(string: string) {
  return string
    .split('_')
    .map((str) => upperFirst(str.split('/').map(upperFirst).join('/')))
    .join('')
}

export function getComparisonStr(diff: number, language: string) {
  if (language === 'en') {
    if (diff < 0) return 'smaller than'
    if (diff > 0) return 'larger than'

    return 'the same as'
  }
  if (language === 'de') {
    if (diff < 0) return 'kleiner als'
    if (diff > 0) return 'größer als'

    return 'genauso groß wie'
  }
  return ''
}

export function getComparisonPayStr(diff: number, language: string) {
  if (language === 'en') {
    if (diff < 0) return 'more than'
    if (diff > 0) return 'less than'

    return 'equal to'
  }
  if (language === 'de') {
    if (diff < 0) return 'mehr als'
    if (diff > 0) return 'weniger als'

    return 'genauso viel wie'
  }
  return ''
}

export function getVerbForModuleStr(module: string, language: string) {
  if (language === 'en') {
    if (module === Module.PAY) return 'earn'
    if (module === Module.WORKING_TIME) return 'work'
    if (module === Module.CAREER) return 'get promoted'
    if (module === Module.TRAINING) return 'get trained'

    return ''
  }
  if (language === 'de') {
    if (module === Module.PAY) return 'verdienen'
    if (module === Module.WORKING_TIME) return 'arbeiten'
    if (module === Module.CAREER) return 'befördert werden'
    if (module === Module.TRAINING) return 'ausgebildet werden'

    return ''
  }
  return ''
}

export function getAdvantageStr(diff: number, language: string) {
  if (language === 'en') {
    if (diff < 0) return 'a disadvantage'
    if (diff > 0) return 'an advantage'
  } else if (language === 'de') {
    if (diff < 0) return 'Vorteil'
    if (diff > 0) return 'Nachteil'
  }
  return ''
}

export function getComparisonTimeStr(diff: number, language: string) {
  if (language === 'en') {
    if (diff < 0) return 'decreased'
    if (diff > 0) return 'increased'

    return 'remained the same'
  }
  if (language === 'de') {
    if (diff < 0) return 'zurückgegangen'
    if (diff > 0) return 'angewachsen'

    return 'gleich geblieben'
  }
  return ''
}

export function getIsDemoAccount() {
  const { account } = useAppSelector((state) => state.currentUser)
  return false // process.env.REACT_APP_SLUG === 'demo' && !account?.isSuperuser
}
